module.exports = __webpack_public_path__ + "static/Plasmoid_DelNoric-17b2c07ea5a3573aab0003ab14eee460.webp";